<template>
  <div class="dashboard">
    <div class="section" v-loading="loading">
      <div class="section-content">
        <p class="title">LEGAL OPINION</p>
        <p class="title-sub">
          What is gambling and how is it different from Skill Games under Indian laws?
        </p>
        <p class="text-0">
          Gambling or gaming has been defined by the Supreme Court in 1996 as betting and wagering on games of 
          chance only. The Supreme Court in this judgment specifically excludes games of skill, irrespective of 
          whether they are played for money or not, from the definition of gambling. The exact quote from the 1996 
          judgment is as follows:
        </p>
        <p class="text-0">
          "The expression 'gaming' in the two Acts has to be interpreted in the light of the law laid-down by this 
          Court in the two1957 cases, wherein it has been authoritatively held that a competition which substantially 
          depends on skill is not gambling. Gaming is the act or practice of gambling on a game of chance. It is 
          staking on chance where chance is the controlling factor. 'Gaming' in the two Acts would, therefore, mean 
          wagering or betting on games of chance. It would not include games of skill like horse racing"
        </p>
        <p class="text-0">
          Further, the Public Gambling Act, which is the central law on gambling and most subsequent state laws on 
          the subject substantially state that "nothing in this Act shall apply to games of mere skill wherever 
          played". This is also mentioned in the 1996 Supreme Court judgment with regards Tamil Nadu and Madras laws.
        </p>
        <p class="text-0">
          "In any case...Section 11 of the Gaming Act specifically saves the games of mere skill from the penal 
          provisions of the two Acts."
        </p>
        <p class="title-sub">
          What is a game of skill under Indian laws?
        </p>
        <p class="text-0">
          Supreme Court of India in 1996 defined a game of mere skill as follows:
        </p>
        <p class="text-0">
          The competitions where success depends on substantial degree of skill are not "gambling" and
        </p>
        <p class="text-0">
          Despite there being an element of chance if a game is preponderantly a game of skill it would nevertheless be a game of "mere skill".
        </p>
        <p class="text-0">
          We, therefore, hold that the expression "mere skill" would mean substantial degree or preponderance of skill.
        </p>
        <p class="title-sub">
          Is rummy a game of skill?
        </p>
        <p class="text-0">
          The 1968 Supreme Court ruling that declared rummy to be a game of skill:
        </p>
        <p class="text-0">
          "Rummy, on the other hand, requires certain amount of skill because the fall of the cards has to be 
          memorised and the building up of Rummy requires considerable skill in holding and discarding cards. 
          We cannot, therefore, say that the game of Rummy is a game of entire chance. It is mainly and 
          preponderantly a game of skill. The chance in Rummy is of the same character as the chance in a deal at a 
          game of bridge."
        </p>
        <p class="text-0">
          Further, the Supreme Court in 1996 also stated
        </p>
        <p class="text-0">
          "A game of skill, on the other hand - although the element of chance necessarily cannot be entirely 
          eliminated --is one in which success depends principally upon the superior knowledge, training, attention, 
          experience and adroitness of the player. Golf, chess and even Rummy are considered to be games of skill. 
          The Courts have reasoned that there are few games, if any, which consist purely of chance or skill, and 
          as such a game of chance is one in which the element of chance predominates over the element of skill, 
          and a game of skill is one in which the element of skill predominates over the element of chance. It is 
          the dominant element --"skill" or "chance" -- which determines the character of the game."
        </p>
        <p class="title-sub">
          Do games of skill enjoy any other protection legally?
        </p>
        <p class="text-0">
          Yes, in 1957 the Supreme Court stated that prize competitions which involve substantial skill are 
          business activities that are protected under Article 19(1)(g) of the Constitution of India.
        </p>
        <p class="title-sub">
          Is it legal to play rummy for cash
        </p>
        <p class="text-0">
          The various Supreme Court rulings and the Gaming Acts of India imply the following:
        </p>
        <p class="text-0">
          Gaming or gambling means betting and wagering on games of chance.
        </p>
        <p class="text-0">
          Playing games of skill for cash does not constitute gambling.
        </p>
        <p class="text-0">
          Games of skill are exempt from the penal provisions of most gambling acts.
        </p>
        <p class="text-0">
          Rummy is a game of skill.
        </p>
        <p class="text-0">
          So yes, it is perfectly legal to play rummy for cash on Rummy as long as you are not playing from the 
          states of Assam, Odisha, Telangana, Andhra Pradesh, Tamil Nadu, Nagaland and Sikkim. As we get more 
          clarity on the laws in these states, we might consider offering our services to residents of these States 
          as well.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // loading: true,
      honorList: [],
      partnerImg: [],
      courseList: [],
      teamItem: [],
      dialogTableVisible: false,
      dialogUrl: "",
      dialogTitle: ""
    };
  }
  // mounted() {
  //   this.$http
  //     .all([
  //       this.$http.get("Honor/GetHonorAll"),
  //       this.$http.get("Enterprise/GetEnterpriseAll"),
  //       this.$http.get(`Team/GetTeamAll`),
  //       this.$http.get(`Course/GetCourseAll`)
  //     ])
  //     .then(
  //       this.$http.spread(
  //         (responseHonor, responseEnterprise, responseTeam, responseCourse) => {
  //           this.honorList = responseHonor.data;
  //           this.partnerImg = responseEnterprise.data;
  //           this.teamItem = responseTeam.data;

  //           var groupCount = Math.ceil(responseCourse.data.length / 2);
  //           window.console.log(groupCount);
  //           for (let i = 0; i < groupCount; i++) {
  //             let img2 = [];
  //             for (let j = 0; j < 2; j++) {
  //               if (responseCourse.data.length - 1 >= i * 2 + j) {
  //                 img2.push(responseCourse.data[i * 2 + j]);
  //               }
  //             }
  //             this.courseList.push(img2);
  //           }
  //           window.console.log(this.courseList);
  //           this.loading = false;
  //         }
  //       )
  //     );
  // }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.dashboard {
  width: 100%;
  height: 100%;
  // background-color: #14679f;
  position: relative;
  overflow: hidden;
  .section {
    // width: 100%;
    // font-size: 20px;
    // font-weight: 400;
    
    width: 62%;
    margin-left: 19%;
    font-family: PingFangSC-Regular;
    font-size: 20px;
    letter-spacing: 0;
    font-weight: 400;

    &-content {
      // width: 1240px;
      // margin: 0 auto;
      // background-color: #fff;

      .title {
        width: 100%;
        font-size: 24px;
        text-align: center;
        margin-top: 26px;
        margin-bottom: 20px;
      }
      .title-sub {
        margin-top: 15px;
      }
      .text-0 {
        margin-top: 15px;
      }
      
    }
  }
}

@keyframes imgboxkey {
  0% {
    border: solid rgb(29, 66, 185) 2px;
  }
  40% {
    border: solid rgb(255, 255, 255) 2px;
  }
  60% {
    border: solid rgb(255, 255, 255) 2px;
  }
  100% {
    border: solid rgb(29, 66, 185) 2px;
  }
}

@keyframes imgbo {
  0% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
  50% {
    transform: scale(1.1);
    box-shadow: 0px 0px 10px 5px #ababab;
  }
  100% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
}
.el-divider--horizontal {
  margin: 1px 0;
}

.top {
  h3,
  p {
    text-align: center;
    color: #3c6088;
    font-weight: 400;
    padding: 10px 0;
  }
  h3 {
    font-size: 30px;
  }
  p {
    font-size: 20px;
  }
  .border {
    border-bottom: 1px solid #3c6088;
    width: 15%;
    margin: 0 auto;
  }
}
.order {
  order: -1;
}
.order-top {
  order: 1;
}
.el-divider {
  background-color: red;
  height: 3px;
  .el-divider__text {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    padding: 0px;
    color: #fff;
    border: 3px solid red;
  }
}
.el-divider-active {
  background-color: #3c6088;
}
.honor-big-img {
  width: 100%;
  height: 100%;
  z-index: 10;
  text-align: center;
  padding-bottom: 20px;
  padding: 5%;
  //background-color: #14679f;
  .el-dialog__wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;

    .el-dialog__body {
      overflow: hidden;
      img {
        width: 100%;
      }
    }
  }
}
</style>